import cx from 'classnames';

import { Typography } from '../../typography/Typography';

import style from './RatingNumber.module.css';

interface RatingNumberProps {
    showRatingNumber: boolean;
    ratingValue: number;
    size: 'xxs' | 'xs' | 'small' | 'medium' | 'large';
    inverse?: boolean;
}

function getTypographyScaleForRatingNumber(size: 'xxs' | 'xs' | 'small' | 'medium' | 'large') {
    if (size === 'large') {
        return 'primary-xl-extra-bold';
    }

    if (size === 'medium') {
        return 'primary-l-extra-bold';
    }

    if (size === 'small') {
        return 'primary-body-bold';
    }

    if (size === 'xs') {
        return 'primary-xs-bold';
    }

    return 'primary-xxs-bold';
}

export function RatingNumber({
    showRatingNumber,
    ratingValue,
    size,
    inverse = false,
}: RatingNumberProps) {
    if (!showRatingNumber) return null;

    return (
        <div className={cx({ [style.inverse]: inverse })}>
            <Typography
                className={style.ratingNumber}
                scale={getTypographyScaleForRatingNumber(size)}
            >
                {ratingValue}
            </Typography>
        </div>
    );
}
